import NewsletterTwentyFourContainer from "./containers/NewsletterTwentyFourContainer";
export default NewsletterTwentyFourContainer;
